import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Navigation from '../components/Navigation';
import './Dashboard.css';

function Dashboard() {
  const { userProfile, isAdmin } = useAuth();

  return (
    <div className="dashboard-container">
      <Navigation />
      
      <div className="dashboard-content">
        <div className="dashboard-header">
          <h1>Welcome, {userProfile?.displayName || 'User'}!</h1>
          <p className="role-badge">{userProfile?.role?.replace('_', ' ').toUpperCase()}</p>
        </div>

        <div className="dashboard-grid">
          <Link to="/projects" className="dashboard-card">
            <div className="card-icon">📋</div>
            <h2>Available Projects</h2>
            <p>Browse and claim projects for your chapter</p>
          </Link>

          <Link to="/my-projects" className="dashboard-card">
            <div className="card-icon">✅</div>
            <h2>My Projects</h2>
            <p>View your chapter's claimed projects</p>
          </Link>

          {isAdmin && (
            <>
              <Link to="/admin/projects" className="dashboard-card admin-card">
                <div className="card-icon">⚙️</div>
                <h2>Manage Projects</h2>
                <p>Create and manage all projects</p>
              </Link>

              <Link to="/admin/chapters" className="dashboard-card admin-card">
                <div className="card-icon">🏛️</div>
                <h2>Manage Chapters</h2>
                <p>View and manage chapters</p>
              </Link>

              <Link to="/admin/interests" className="dashboard-card admin-card">
                <div className="card-icon">📩</div>
                <h2>View Interests</h2>
                <p>See who expressed interest</p>
              </Link>
            </>
          )}
        </div>

        <div className="info-section">
          <h3>📢 Recent Activity</h3>
          <p>Check the projects page to see newly available opportunities!</p>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
